import React from "react";
import { renderMultipleCommasWithDescription } from "./InSilicoPredictionsHelpers";
import * as urls from "./InSilicoPredictionsUrls";
import VersionText from "../../../../components/atoms/VersionText";
import HelperText from "../../../../components/atoms/HelperText";

export const displayDbnsfpDbscnvData = (dbnsfpDbscsnv, schema, thresholds) => {
  const dbscsnv = Array.isArray(dbnsfpDbscsnv) ? dbnsfpDbscsnv[0] : {};
  return (
    <div>
      <table className="varsome-table">
        <tbody>
          {(dbscsnv.ada_score || dbscsnv.rf_score) && (
            <tr className="dbnsfp-row">
              <td width="20%">
                <a href={urls.dbnsfpUrl} target="_blank">
                  {"dbscSNV "}
                </a>
                <HelperText fieldDescriptionKey="dbscSNV" />
                <br />
                {dbnsfpDbscsnv && (
                  <VersionText versionText={dbnsfpDbscsnv[0].version} />
                )}
              </td>
              {renderMultipleCommasWithDescription(
                dbscsnv,
                "ada_score",
                schema.dbnsfp_dbscsnv.items.properties.ada_score.label,
                true,
                schema.dbnsfp_dbscsnv.items.properties.ada_score.label,
                true,
                true,
                thresholds,
                "scsnv_ada"
              )}
              {renderMultipleCommasWithDescription(
                dbscsnv,
                "rf_score",
                schema.dbnsfp_dbscsnv.items.properties.rf_score.label,
                true,
                schema.dbnsfp_dbscsnv.items.properties.rf_score.label,
                true,
                true,
                thresholds,
                "scsnv_rf"
              )}
              <td />
              <td />
              <td />
              <td />
            </tr>
          )}
        </tbody>
      </table>
      <br />
    </div>
  );
};
